<template>
  <el-dialog title="术语审核" :visible="visible" @close="closeDialog" center>
    <el-dialog width="40%" :visible.sync="innerVisible" append-to-body>
      <div v-for="(item, index) in exampleList" :key="index">
        <div style="padding: 10px">{{ index + 1 }}. {{ item }}</div>
      </div>
    </el-dialog>
    <avue-crud
      :option="termAuditOption"
      :data="termAuditData"
      :page.sync="termPage"
      @on-load="getTermList"
    >
      <template slot="checkStatus" slot-scope="scope">
        <el-radio v-model="scope.row.checkStatus" :label="2">采纳</el-radio>
        <el-radio v-model="scope.row.checkStatus" :label="3">不采纳</el-radio>
      </template>
      <template slot="example" slot-scope="scope">
        <el-button type="success" plain @click="getTextList(scope.row.srcText)">
          查看例句
        </el-button>
      </template>
    </avue-crud>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="submit">提 交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { termAuditOption } from '@/const/crud/qc/qcflow';
import { statistics } from '@/api/dot/flow';
import { textList, qcAuditTask, pageTermList } from '@/api/dot/qc';

// 审核状态映射
const qcAuditStatusMap = {
  '-1': '参数不能为空',
  '-2': '没有审核的数据',
  '-3': '没有权限',
};

export default {
  name: 'TermAuditDialog',
  props: ['visible', 'staParams', 'orderId', 'userInfo', 'qcTaskId'],
  data() {
    return {
      innerVisible: false, // 查看例句弹窗显示
      termAuditOption: termAuditOption,
      termAuditData: [],
      exampleList: [], // 查看例句列表
      termPage: {
        pageSize: 20,
        pagerCount: 5,
        currentPage: 1,
        total: 0,
      },
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.getTermList();
      }
    },
  },
  mounted() {
    // 组件加载需要拉一次数据，提供父组件红点显示的能力
    this.getTermListSvr();
  },
  methods: {
    // 查询例句
    getTextList(srcText) {
      textList({ orderId: this.orderId, srcText: srcText }).then((res) => {
        this.exampleList = res.data.data;
        if (!this.exampleList.length) {
          this.$message.warning('此条暂无例句');
        } else {
          this.innerVisible = true;
        }
      });
    },
    // 分页拉取术语审核列表接口调用
    getTermListSvr() {
      return pageTermList(
        Object.assign({
          orderId: this.orderId,
          currPage: this.termPage.currentPage,
          pageSize: this.termPage.pageSize,
        }),
      ).then((res) => {
        const data = res?.data?.data;
        this.termAuditData = data?.records;
        this.termPage.total = data?.total;
        // 触发父组件“术语审核”的小红点展示逻辑
        this.$emit('trigger-dot', this.termAuditData?.length > 0);
      });
    },
    // 分页拉取术语审核列表
    getTermList() {
      this.getTermListSvr();
      statistics(
        Object.assign(
          {
            event_name: '术语审核',
            event_type: 'click',
          },
          this.staParams,
        ),
      );
    },
    // 提交审核
    submit() {
      let filterResult = this.termAuditData?.filter(
        (it) => it.checkStatus !== null,
      );
      if (filterResult?.length > 0) {
        let map = filterResult.map((i) => {
          return {
            id: i.taskId,
            termId: i.termId,
            checkStatus: i.checkStatus,
          };
        });
        qcAuditTask(
          Object.assign(
            {
              orderId: this.orderId,
              qcId: this.userInfo?.staffId,
              qcTaskId: this.qcTaskId,
            },
            { list: map },
          ),
        ).then((res) => {
          const data = res?.data?.data;
          if (data > 0) {
            // 提交完成关闭弹窗
            this.getTermListSvr();
            return this.closeDialog();
          }
          this.$message.error(qcAuditStatusMap[data.toString()] ?? '提交失败');
        });
      } else {
        this.$message.info('请选择至少选择一个审核结果提交！');
      }
    },
    // 关闭弹窗回调
    closeDialog() {
      this.$emit('update:visible', false);
    },
  },
};
</script>
